module.exports = __webpack_public_path__ + "img/list01-sp.02bd3725.png";